import RegraComissaoVendedorService from "@/services/RegraComissaoVendedorService";

export const regraComissaoVendedor = {
  namespaced: true,
  state: {
    regraComissaoVendedor: {},
  },
  actions: {
    getRegraComissaoVendedor({ commit }, payload) {
      return RegraComissaoVendedorService.GetRegraComissaoVendedor(
        payload
      ).then(
        (regraComissaoVendedor) => {
          return Promise.resolve(regraComissaoVendedor);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postRegraComissaoVendedor({ commit }, payload) {
      return RegraComissaoVendedorService.PostRegraComissaoVendedor(
        payload
      ).then(
        (regraComissaoVendedor) => {
          return Promise.resolve(regraComissaoVendedor);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putRegraComissaoVendedor({ commit }, payload) {
      return RegraComissaoVendedorService.PutRegraComissaoVendedor(
        payload
      ).then(
        (regraComissaoVendedor) => {
          return Promise.resolve(regraComissaoVendedor);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteRegraComissaoVendedor({ commit }, payload) {
      return RegraComissaoVendedorService.DeleteRegraComissaoVendedor(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getRegraComissaoVendedorOData({ commit }, payload) {
      return RegraComissaoVendedorService.GetRegraComissaoVendedorOData(
        payload
      ).then(
        (regraComissaoVendedor) => {
          return Promise.resolve(regraComissaoVendedor);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default regraComissaoVendedor;
